const initialState = {
    groupSetups: [],
    groupNames: [],
    gridGroupSetupConfiguration: {
        fielddata: [],
        instances: [],
    },
    mappedDataDictionaries: [],
    unMappedDataDictionaries: [],
    linkedMappedDataDictionaries: [],
    linkedUnMappedDataDictionaries: [],

    groupFieldSourceMappings: [],
    defaultSelectedSources: [],
    selectedSourceNames: [],
    resetMappedDD: [],
    groupDDConfigs: [],
    gcRuleNames: [],
    linkGroupIndex: '',
    groupSettings: [],
    groupLockInfo: [],
};

export default initialState;
